import * as React from "react"
import { defaultLang } from "../utils/default-options"

const LocaleContext = React.createContext(defaultLang)
const LocationContext = React.createContext();

const LocationProvider =({
  location,
  children,
}) => <LocationContext.Provider value={location}>{children}</LocationContext.Provider>

const LocaleProvider = ({
  children,
  pageContext: { locale = defaultLang },
}) => <LocaleContext.Provider value={locale}>{children}</LocaleContext.Provider>

export { LocaleContext, LocationContext, LocationProvider, LocaleProvider }
